import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUpdatePlateByTripIDResponse } from 'src/app/interfaces/Responses/IUpdatePlateByTripIDResponse';
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  url: string = environment.urlBaseService
  _urlBase = `${this.url}RealTimesTrucktDetail`

  constructor(private httpClient: HttpClient) { }

  updatePlateByTripID(tripId: string, plateNumber: string): Observable<IUpdatePlateByTripIDResponse> {
    return this.httpClient.put<IUpdatePlateByTripIDResponse>(`${this._urlBase}?TripId=${tripId}&Plate=${plateNumber.toUpperCase()}`, '')
  }
}
